import React, { useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  UPLOAD_FILES_COMMENT_REQUEST,
} from '../../redux/constants/constants';
import TextField from '@material-ui/core/TextField';
import './IncidentSidebar.scss';

const MAX_FILE_SIZE_MB = 10;

export default function UploadForm({ handleSubmit }) {
  const dispatch = useDispatch();
  const uploading = useSelector(
    (state) => state.IncidentSidebarReducer.uploading
  );
  const progress = useSelector(
    (state) => state.IncidentSidebarReducer.progress
  );
  const [files, setFiles] = useState([]);
  const [comment, setComment] = useState('');
  const dropRef = useRef();

  const handleFiles = (incomingFiles) => {
    const validFiles = [...incomingFiles].filter(file => file.size <= MAX_FILE_SIZE_MB * 1024 * 1024);
    setFiles(prev => [...prev, ...validFiles]);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    handleFiles(e.dataTransfer.files);
  };

  const handleFileInput = (e) => {
    handleFiles(e.target.files);
  };

  const removeFile = (index) => {
    setFiles(prev => prev.filter((_, i) => i !== index));
  };

  return (
    <div className="inc-upload-root">
      {/* Comment Textarea */}
      <TextField
        multiline
        rows={4}
        variant="outlined"
        fullWidth
        value={comment}
        onChange={e => setComment(e.target.value)}
        placeholder="Type your comment here..."
      />

      {/* Drag and Drop Area */}
      <div
        ref={dropRef}
        onDrop={handleDrop}
        onDragOver={e => e.preventDefault()}
        onClick={() => dropRef.current.querySelector('input').click()}
        className="inc-upload-dropzone"
        onMouseEnter={e => e.currentTarget.classList.add('inc-upload-dropzone-hover')}
        onMouseLeave={e => e.currentTarget.classList.remove('inc-upload-dropzone-hover')}
      >
        Drag & drop files or click to select
        <input
          type="file"
          multiple
          hidden
          onChange={handleFileInput}
        />
      </div>

      {/* File List */}
      <ul className="inc-upload-filelist">
        {files.map((file, idx) => (
          <li
            key={idx}
            className="inc-upload-fileitem"
          >
            <span>{file.name} ({(file.size / 1024 / 1024).toFixed(2)} MB)</span>
            {progress.percent != null && (
              <span className="inc-upload-progress">{progress.percent}%</span>
            )}
            <button
              onClick={() => removeFile(idx)}
              className="inc-upload-remove-btn"
            >
              Remove
            </button>
          </li>
        ))}
      </ul>

      {/* Submit Button */}
      <button
        onClick={() => handleSubmit(files, comment)}
        disabled={uploading || !comment.trim()}
        className={`inc-upload-submit-btn${uploading || !comment.trim() ? ' disabled' : ''}`}
      >
        {uploading ? 'Uploading...' : 'Submit'}
      </button>
    </div>
  );
}
